import initRouteInfo from '@/helper-functions/route-info/init-route-info';
import { makeMutations } from '@/helper-functions/store/store';

export const state = () => ({
  routeInfo: initRouteInfo(),
});
export const mutations = {
  ...makeMutations(['routeInfo']),
};
